import Grid from '@mui/material/Unstable_Grid2';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { getLabelFromJspVariables } from '../common/JspUtil';

// Activate a click handler on Enter/Space so Box-based controls behave like buttons.
const onKeyActivate = (handler) => (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        handler(e);
    }
};

const AppSelector = ({ apps, nonLauncher, favorites, onIconClick, toggleFavorite, handleHelpToggle }) => (
    <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))', py: 1, gap: 2 }}>
                {apps.map((icon, i) => {
                    const appIdentifier = icon.app;
                    const isFavorite = favorites && appIdentifier && favorites.includes(appIdentifier);
                    return (
                        <Box key={appIdentifier || i}
                            role="button"
                            tabIndex={0}
                            aria-label={icon.iconDisplayName}
                            sx={{ cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center'}}
                            onClick={e => onIconClick(e, icon)}
                            onKeyDown={onKeyActivate(e => onIconClick(e, icon))}>
                            <img src={icon.iconUrl} alt={icon.iconDisplayName} width="48" height="48" />
                            {nonLauncher &&
                                <Box component="span" sx={{ mt: '-50px', ml: '25px', height: '45px' }}>
                                    <svg style={{ paddingLeft: '5px', height: '19px', width: '19px' }} fill="orange" viewBox="128 0 1536 1792">
                                        <path d="M896 128q209 0 385.5 103t279.5 279.5 103 385.5-103 385.5-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103zm128 1247v-190q0-14-9-23.5t-22-9.5h-192q-13 0-23 10t-10 23v190q0 13 10 23t23 10h192q13 0 22-9.5t9-23.5zm-2-344l18-621q0-12-10-18-10-8-24-8h-220q-14 0-24 8-10 6-10 18l17 621q0 10 10 17.5t24 7.5h185q14 0 23.5-7.5t10.5-17.5z" />
                                    </svg>
                                </Box>
                            }
                            <Typography variant="caption">{icon.iconDisplayName}</Typography>
                            {icon.iconName2 && <Typography variant="caption" >{icon.iconName2}</Typography>}
                            {(icon.iws || appIdentifier || (icon.helpNote && icon.helpNote.trim() !== '')) && (
                                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '4px' }}>
                                    {icon.iws && (
                                        <Box component="span" title={getLabelFromJspVariables('label_ice_web_start')} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                            <svg width="12" height="12" viewBox="0 0 24 24" fill="#B71C1C"><circle cx="12" cy="14" r="8" /></svg>
                                        </Box>
                                    )}
                                    {appIdentifier &&
                                        <Box title={isFavorite ? 'Remove from Favorites' : 'Add to Favorites'}
                                            role="button"
                                            tabIndex={0}
                                            aria-label={isFavorite ? 'Remove from Favorites' : 'Add to Favorites'}
                                            aria-pressed={isFavorite}
                                            onClick={(e) => { e.stopPropagation(); toggleFavorite(appIdentifier); }}
                                            onKeyDown={onKeyActivate((e) => { e.stopPropagation(); toggleFavorite(appIdentifier); })}
                                            sx={{ cursor: 'pointer', backgroundColor: 'rgba(255,255,255,0.8)', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                            {isFavorite ? (
                                                <StarIcon sx={{ color: '#fbc02d', fontSize: 14 }} />
                                            ) : (
                                                <StarBorderIcon sx={{ color: '#bdbdbd', fontSize: 14 }} />
                                            )}
                                        </Box>
                                    }
                                    {icon.helpNote && icon.helpNote.trim() !== '' &&
                                        <Box component="span" title={getLabelFromJspVariables('label_more_info')}
                                            role="button"
                                            tabIndex={0}
                                            aria-label={getLabelFromJspVariables('label_more_info')}
                                            onClick={(e) => { e.stopPropagation(); handleHelpToggle(e, icon.helpNote, icon.iconDisplayName); }}
                                            onKeyDown={onKeyActivate((e) => { e.stopPropagation(); handleHelpToggle(e, icon.helpNote, icon.iconDisplayName); })}
                                            sx={{ cursor: 'pointer', backgroundColor: 'rgba(255,255,255,0.8)', borderRadius: '50%', p: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', color: '#000', minWidth: '18px', minHeight: '18px' }}>
                                            <InfoOutlinedIcon sx={{ fontSize: 14 }} />
                                        </Box>
                                    }
                                </Box>
                            )}
                        </Box>
                    );
                })}
            </Box>
);

export default AppSelector;
